import styled from 'styled-components';

const ContentDiv = styled.div`
  grid-area: content;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-row-gap: 0.5rem;
  grid-template-areas:
    'description'
    'camera';
  justify-items: center;
  align-items: flex-start;
  overflow: hidden;
`;

const DescriptionText = styled.p`
  grid-area: description;
  text-align: center;
  font-size: 1rem;
`;

const MainCameraDiv = styled.div`
  grid-area: camera;
  width: 80%;
  height: 80%;
`;

const SelfieIndicationDiv = styled.div`
  border-radius: 25px;
  border: 3px ${(p) => p.theme.primary} solid;
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Img = styled.img`
  width: 50%;
  object-fit: contain;
`;

const SelfieText = styled.p`
  margin-top: 0.5rem;
  width: 75%;
  font-size: 1.1rem;
`;

const Bluespan = styled.span`
  color: ${(p) => p.theme.primary};
  font-weight: 800;
`;
const ImagePreview = styled.img`
  padding: 0.1rem;
  border-radius: 20px;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border: 2px ${(p) => p.theme.accent} solid;
`;

const ButtonDiv = styled.div`
  gird-area: buttons;
`;

export {
  ContentDiv,
  DescriptionText,
  MainCameraDiv,
  SelfieIndicationDiv,
  Img,
  SelfieText,
  Bluespan,
  ImagePreview,
  ButtonDiv
}